import { defineComponent, computed } from "vue";
import { V as VaFileUploadListItem } from "../VaFileUploadListItem/index-1bf4acb1.mjs";
import { V as VaFileUploadGalleryItem } from "../VaFileUploadGalleryItem/index-2c0719bc.mjs";
import { V as VaFileUploadSingleItem } from "../VaFileUploadSingleItem/index-19908b4a.mjs";
import { b as VaList } from "../../va-list/index-82910b3a.mjs";
import { e as extractComponentProps } from "../../../utils/component-options/extract-component-options-6b96d215.mjs";
import { f as filterComponentProps } from "../../../utils/component-options/filter-props-9727421a.mjs";
const VaFileUploadGalleryItemProps = extractComponentProps(VaFileUploadGalleryItem);
const VaFileUploadListItemProps = extractComponentProps(VaFileUploadListItem);
const VaFileUploadSingleItemProps = extractComponentProps(VaFileUploadSingleItem);
const _sfc_main = defineComponent({
  name: "VaFileUploadList",
  components: {
    VaList,
    VaFileUploadListItem,
    VaFileUploadGalleryItem,
    VaFileUploadSingleItem
  },
  emits: ["remove", "removeSingle"],
  props: {
    type: { type: String, default: "" },
    files: { type: Array, default: null },
    ...VaFileUploadGalleryItemProps,
    ...VaFileUploadListItemProps,
    ...VaFileUploadSingleItemProps
  },
  setup(props) {
    const filesList = computed(() => props.files.map(convertFile));
    const convertFile = (file) => ({
      name: file.name || file.url || "",
      size: formatSize(file.size),
      date: formatDate(/* @__PURE__ */ new Date()),
      image: file
    });
    const formatSize = (bytes) => {
      if (bytes === 0) {
        return "0 Bytes";
      }
      if (!bytes) {
        return "";
      }
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };
    const formatDate = (date = /* @__PURE__ */ new Date()) => {
      return date.toLocaleDateString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        month: "short",
        day: "numeric",
        year: "numeric"
      });
    };
    return {
      galleryItemProps: filterComponentProps(VaFileUploadGalleryItemProps),
      itemProps: filterComponentProps(VaFileUploadListItemProps),
      singleItemProps: filterComponentProps(VaFileUploadSingleItemProps),
      filesList
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../VaFileUploadList.css';
//# sourceMappingURL=VaFileUploadList.vue_vue_type_script_lang-f5cf6ed3.mjs.map
